import React                     from 'react';
import { chooseService }         from "../../../utils";
import ExportModeCayugaButtons   from "../ExportModeCayugaButtons";
import ExportModeOcularisButtons from "../ExportModeOcularisButtons";

interface Props {
  triggerMode: (mode: string) => void,
  mode: string
}

const ExportModeButtons: React.FC<Props> = ({triggerMode, mode}) => {
  return (
    <div className={'exports-buttons'}>
      {
        chooseService(
          () => <ExportModeOcularisButtons mode={mode} triggerMode={triggerMode}/>,
          () => <ExportModeCayugaButtons mode={mode} triggerMode={triggerMode}/>
        )
      }
    </div>
  )
};

export default ExportModeButtons